export * from './GlobalStyles';
export { default } from './GlobalStyles';
